import React from 'react';
import { Maximize2 } from 'lucide-react';

export default function WidgetCard({ title, icon, count, children, onExpand, footer, headerAction }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div
        onClick={onExpand}
        className="flex items-center justify-between px-4 py-2.5 border-b border-gray-100 bg-gray-50/80 cursor-pointer hover:bg-gray-100 transition-colors group"
      >
        <div className="flex items-center gap-2">
          {icon && <span className="text-sm">{icon}</span>}
          <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">{title}</h3>
          {count !== undefined && (
            <span className="text-[10px] bg-gray-200 text-gray-600 px-1.5 py-0.5 rounded-full font-medium">{count}</span>
          )}
        </div>
        <div className="flex items-center gap-1.5">
          {headerAction}
          <Maximize2 className="h-3 w-3 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>
      </div>
      <div className="max-h-[200px] overflow-y-auto">
        {children}
      </div>
      {footer && (
        <div className="border-t border-gray-100">
          {footer}
        </div>
      )}
    </div>
  );
}
